/**
 * エージェントの顔を安全に表示する共有コンポーネント。
 *
 * 2026-06-12 バグ: profile.icon が SVG 文字列（JARVIS 等）のとき、ヘッダーが
 * `<span>{icon}</span>` のように raw 表示していたため、アバター画像が読み込まれる
 * までの一瞬、SVG ソース（約5〜7行）がテキストとして画面上部に見えていた。
 *
 * このコンポーネントは icon を**決してテキストとして描画しない**:
 *   - 画像（avatarUrl）があれば <img>
 *   - icon が SVG 文字列なら sanitize して SVG として描画
 *   - それ以外（絵文字など短い文字列）はそのまま表示
 *   - どれでもなければ中立の 🤖
 */
import { sanitizeAvatarSvg } from "@/lib/avatar"

type Props = {
  avatarUrl?: string
  icon?: string
  size?: number
  className?: string
}

export function AgentFace({ avatarUrl, icon, size = 24, className }: Props) {
  const px = `${size}px`

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        style={{ width: px, height: px }}
        className={`rounded-full object-cover ${className || ""}`}
      />
    )
  }

  const trimmed = (icon || "").trim()
  if (trimmed.startsWith("<svg")) {
    const safe = sanitizeAvatarSvg(trimmed)
    if (safe) {
      return (
        <span
          style={{ width: px, height: px, display: "inline-block" }}
          className={className}
          // sanitizeAvatarSvg は厳格 allowlist 済み（XSS 対策）
          dangerouslySetInnerHTML={{ __html: safe }}
        />
      )
    }
    // SVG だが不正 → raw テキストは絶対に出さず中立フォールバック
    return <span style={{ fontSize: size * 0.8 }}>🤖</span>
  }

  // 絵文字など短い文字列、または未設定
  return <span style={{ fontSize: size * 0.8 }}>{trimmed || "🤖"}</span>
}
